/* eslint-disable react/jsx-indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Divider, Typography, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BackButton from '../components/Buttons/BackButton';
import UserFormSteps from '../components/FormContainers/CreateUserForm/UserFormSteps';
import FormSkeleton from '../components/Skeletons/FormSkeleton';
import { eliminateOjectNotTruthyValues } from '../lib/helperFuncs';
import HttpService from '../services/HttpService';
import Theme from '../Themes/main.theme';
import { IUserForm } from './CreateUser';
import UserService from '../services/UserService';
import { PermissionsManageInternalUsers } from '../lib/permissions';
import { useUserDbInfo } from '../hooks/UserInfo';
import DialogAction from '../components/Dialog/DialogAction';

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { pathname } = useLocation();

  const [data, setData] = useState<IUserForm>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { userDbInfo, loading: loadingUserDbInfo } = useUserDbInfo();

  const validateUserCanViewPage = (data: any) => {
    const canViewAll = UserService
      .hasRole([PermissionsManageInternalUsers.PermissionsInternalUsersManageCreateAll]);
    const canViewMyOrg = UserService
      .hasRole([PermissionsManageInternalUsers.PermissionsInternalUsersManageCreateMyOrg]);

    if (!canViewAll && !canViewMyOrg) {
      navigate('/');
    }

    if (!canViewAll && canViewMyOrg
      && userDbInfo.administrative_unit_id !== data?.administrative_unit_id) {
      navigate('/');
    }

  };

  const getData = async () => {
    try {
      const response = id
        ? await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users/${id}`)
        : await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users/user`);
      validateUserCanViewPage(response.data);
      setData(response.data);
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    getData();
  }, []);

  const onSubmit = async (values: IUserForm) => {
    setIsLoading(true);
    try {
      const response = await HttpService.getAxiosClient().patch(`${process.env.REACT_APP_BACKEND_URL}/users/${id
        ? id
        : data?.id}`,
      eliminateOjectNotTruthyValues({
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        phone_number: values.phone_number,
        afm: values.afm,
        groups: values.roles,
        administrative_unit_id: values.administrative_unit_id,
        is_enabled: values.is_enabled
      })
      );
      if (response.status === 200) {
        id
          ? navigate('/admin/users/dashboard')
          : navigate('/admin/profile');
        enqueueSnackbar(t('Επιτυχής Επεξεργασία'), { variant: 'success' });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.'), { variant: 'error' });
    }
    setIsLoading(false);
  };

  const [openModal, setOpenModal] = useState<boolean>(false);
  const onChangePasswordSubmit = async () => {
    try {
      const body = { id: data?.id };
      const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/users/password`, body);
      if (response.status === 201) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else {
        // Επειδη μερικές φορές laggarei και ερχονται τα emails από keycloak με καθυστέρηση (πχ 10 λεπτών).
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar(t('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.'), { variant: 'error' });
      console.error(error);
    }
  };

  return (
    <>
      <Box mt={2} mb={2}>
        <BackButton onClick={() => navigate(-1)} />
      </Box>
      {pathname.includes('/profile/edit') && <> <DialogAction open={openModal} handleClose={() => setOpenModal(false)}
        title={String(t('Αλλαγή Κωδικού'))
        }
        content={t('Θα σας σταλεί ένα ενημερωτικό email για να αλλάξετε τον κωδικό σας. Είστε σίγουρος/η ότι θέλετε να προχωρήσετε;')}
        onAccept={() => {
          onChangePasswordSubmit();
          setOpenModal(false);
        }} />
      <Box display='flex' mr={5}
        justifyContent='flex-end' >
        <Button variant='contained' onClick={() => setOpenModal(true)}
          sx={{ '&:hover': { cursor: 'pointer'} 
          }}>
          {t('Αλλαγή Κωδικού')}
        </Button>
      </Box></>}
      <Typography sx={{ my: 2 }} variant='h2'
        color={Theme?.labelColor?.main}>{t('Επεξεργασία Χρήστη')}</Typography>
      <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />
      {data
        ? <UserFormSteps
          isLoading={isLoading}
          initialValues={data}
          onSubmit={onSubmit}
          edit />
        : <FormSkeleton lines={6} />
      }


    </>
  );
};

export default EditUser;